export const EMBED_AI_OPENED_FF = 'embed-ai-opened';
